import border from '../../border';

const primary = (params) => border.active.primary(params);

export default primary;
